import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import type { ContentSnapshot } from './lib/contentSnapshot';
import './index.css';

const container = document.getElementById('root')!;
const snapshotElement = document.getElementById('site-content');
const initialSnapshot: ContentSnapshot | undefined = snapshotElement?.textContent ? JSON.parse(snapshotElement.textContent) : undefined;
const application = <StrictMode><BrowserRouter><App initialSnapshot={initialSnapshot} /></BrowserRouter></StrictMode>;
if (container.hasChildNodes()) hydrateRoot(container, application);
else createRoot(container).render(application);
